<template>
  <div class="listening-review">
    <p v-if="reason" class="assessment-reason">{{ reason }}</p>
    <QuestionReview :items="reviewItems" v-slot="{ item, index }">
      <article>
        <h3>{{ $t('levelTest.questionNumber', { n: index + 1 }) }} · {{ $t(item.type === 'choice' ? 'levelTest.comprehensionType' : 'levelTest.dictationType') }}</h3>
        <p v-if="item.question" lang="en" class="question">{{ item.question }}</p>
        <p class="answer-label">{{ $t('levelTest.selectedAnswer') }}</p>
        <p lang="en" class="answer">{{ item.response || $t('levelTest.notHeard') }}</p>
        <template v-if="item.type === 'choice'">
          <p class="verdict">{{ item.correct ? '✓' : '×' }} {{ $t(item.correct ? 'levelTest.correct' : 'levelTest.incorrect') }}</p>
          <p v-if="!item.correct"><strong>{{ $t('levelTest.correctAnswer') }}</strong> <span lang="en">{{ item.answer }}</span></p>
        </template>
        <template v-else>
          <p class="answer-label">{{ $t('levelTest.referenceSentence') }}</p>
          <p lang="en" class="answer">{{ item.answer }}</p>
          <DictationComparison v-if="item.dictation.accuracy < 100" :grade="item.dictation" />
          <p v-else class="verdict">✓ {{ $t('levelTest.correct') }}</p>
        </template>
        <audio :key="item.id" controls preload="none" :src="item.audioUrl" :aria-label="$t('levelTest.replayQuestion', { n: index + 1 })"></audio>
        <details v-if="item.type === 'choice'" class="transcript-details">
          <summary>{{ $t('levelTest.originalAndExplanation') }}</summary>
          <p lang="en">{{ item.transcript }}</p>
          <p>{{ item.explanation[language] }}</p>
          <p class="source">{{ item.source.title }}</p>
        </details>
      </article>
    </QuestionReview>
  </div>
</template>

<script>
import QuestionReview from './QuestionReview.vue'
import DictationComparison from './DictationComparison.vue'

export default {
  name: 'ListeningReview',
  components: { QuestionReview, DictationComparison },
  props: { result: { type: Object, required: true } },
  computed: {
    language() { return this.$i18n.locale.startsWith('zh') ? 'zh' : 'en' },
    reason() { return String(this.result.reason || '').split(/(?<=[。！？])\s*|(?<=[.!?])\s+/)[0] },
    reviewItems() {
      return this.result.items.map(item => {
        const correct = item.type === 'choice' ? item.correct : item.dictation.accuracy === 100
        const partial = item.type === 'dictation' && item.dictation.accuracy > 0 && !correct
        return { ...item, mark: correct ? '✓' : partial ? '·' : '×',
          statusLabel: this.$t(correct ? 'levelTest.correct' : partial ? 'levelTest.partialAnswer' : 'levelTest.incorrect') }
      })
    }
  }
}
</script>

<style scoped>
.listening-review { color: var(--ink-primary); text-align: left; font-size: var(--font-size-sm); line-height: 1.6; }
.assessment-reason { margin: 0 0 var(--space-5); color: var(--ink-secondary); }
h3 { margin: 0; color: var(--ink-secondary); font-size: var(--font-size-sm); font-weight: 500; }
p { margin: var(--space-2) 0 0; }
.question { font-size: var(--font-size-md); font-weight: 500; }
.answer-label { margin-top: var(--space-4); color: var(--ink-secondary); font-size: var(--font-size-xs); }
.answer { margin-top: var(--space-1); }
.verdict { font-weight: 600; }
audio { display: block; min-width: 0; max-width: 100%; width: 100%; margin-top: var(--space-4); }
.transcript-details { margin-top: var(--space-2); color: var(--ink-secondary); }
summary { min-height: 44px; align-content: center; cursor: pointer; }
summary:focus-visible { outline: 2px solid var(--signal-active-strong); outline-offset: 2px; }
.source { font-size: var(--font-size-xs); }
</style>
